/**
 * Returns List of unsupported languages based on the environment.
 * Supported languages: EN, ES, FR, PT, AR, IT, RU, BN, DE, KO, SW, VI, ZH_CN, ZH_TW, PL, SI, TA, MN
 */
export const UNSUPPORTED_LANGUAGES = ['ID', 'TH', 'KM', 'UZ', 'TR', 'AR'];
